import React from "react"
import { TwStyle } from "twin.macro"
import { useLottie, Lottie, AnimationData } from "react-lottie-hook"

interface LottieAnimationProps {
  animationData: AnimationData
  width: string | number
  height: string | number
  twStyle?: TwStyle | string
}

export const LottieAnimation = ({ twStyle, width, height, animationData }: LottieAnimationProps) => {
  const [lottieRef] = useLottie({
    loop: true,
    animationData,
  })
  return (
    <div data-chromatic="ignore" data-testid="animation" tw="inline-block items-center justify-center" css={twStyle}>
      <Lottie data-chromatic="ignore" lottieRef={lottieRef} style={{ margin: "auto", width, height }} />
    </div>
  )
}
